import admin from './view';

export default [
  {
    path: '/',
    redirect: '/process',
  },
  {
    path: 'process', // 심의 후 처리 대상 목록
    component: admin('/issue/processList'),
  },
  {
    path: 'process/:sq', // 심의 후 처리 상세보기
    component: admin('/issue/processDetail'),
  },
  {
    path: 'issueCertification', // 상세보기 및 관리 UI 인증번호 부여
    component: admin('/issue/issueCertification'),
  },
  {
    path: 'reissueCertification', // 상세보기 및 관리 UI-인증서재발급
    component: admin('/issue/reissueCertification'),
  },
  {
    path: 'acceptance', // 합격 통보 및 계약 진행 p
    component: admin('/issue/acceptance'),
  },
  {
    path: 'failure', // 불합격 통보
    component: admin('/issue/failure'),
  },
  {
    path: 'reissue', // 인증서 재발급/변경신청목록
    component: admin('/issue/reissueList'),
  },
  {
    path: 'reissue/:sq', // 인증서재발급/변경관리- 상세보기 및 관리
    component: admin('/issue/reissueDetail'),
  },
  {
    path: 'reissueEng', // 영문인증서 발급관리-신청목록
    component: admin('/issue/reissueEngList'),
  },
  {
    path: 'reissueEng/:sq', // 영문인증서 발급관리-상세보기 및 관리
    component: admin('/issue/reissueEngDetail'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/issue.js